import { render, staticRenderFns } from "./ModalBackofficeAssinaturaMedico.vue?vue&type=template&id=9498136e&scoped=true"
import script from "./ModalBackofficeAssinaturaMedico.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeAssinaturaMedico.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeAssinaturaMedico.vue?vue&type=style&index=0&id=9498136e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9498136e",
  null
  
)

export default component.exports